import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './ViewButton.less'

interface ViewButtonProps {
  onView: () => void
  tooltipText?: string
  className?: string
}

export const ViewButton: React.FC<ViewButtonProps> = ({
  onView,
  tooltipText = 'View',
  className = ''
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = () => {
    onView()
  }

  return (
    <div className={`view-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="view-button"
        onClick={handleClick}
        aria-label="View"
        title={tooltipText}
      >
        <Icon
          name={IconName.View}
          className="view-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
